import { ofType } from "redux-observable";
import { tap, ignoreElements, filter, map } from "rxjs/operators";
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

const toasterSlice = createSlice({
  name: "toaster",
  initialState: {},
  reducers: {
    showNotification(_state, _action) {},
  },
});

export const { showNotification } = toasterSlice.actions;

const showToastsEpic = (action$, _state$, { toaster }) =>
  action$.pipe(
    ofType(showNotification.type),
    tap(({ payload }) => toaster.show(payload)),
    ignoreElements()
  );

const successNotificationEpic = (action$) =>
  action$.pipe(
    filter((action) => Boolean(action.meta?.notificationOnSuccess)),
    map((action) =>
      showNotification({
        message: action.meta.notificationOnSuccess,
        intent: "success",
      })
    )
  );

const failureNotificationEpic = (action$) =>
  action$.pipe(
    filter((action) => action.type.endsWith("Failure")),
    filter((action) => Boolean(action.meta?.errorMessage)),
    map((action: PayloadAction<unknown>) =>
      showNotification({
        message: action.meta.errorMessage,
        intent: "danger",
      })
    )
  );

export default {
  ...toasterSlice,
  middleware: [
    showToastsEpic,
    successNotificationEpic,
    failureNotificationEpic,
  ],
};
